import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from '../../styles/styled';
import { Button } from '../buttons';
import { Row } from '../layout';
import { Modal } from '../modal/modal';
import { AppText } from '../typography';
export const IFrameModal = ({ className, isOpen, onClose, onOpen, src, submit, submitText, }) => {
    return (_jsxs(Modal, { className: className, contentStyle: className ? null : { width: '95vw' }, isOpen: isOpen, onClose: () => onClose(), onOpen: onOpen, styleOverride: {
            card: {
                height: '95vh',
            },
        }, children: [_jsx(AppText, { as: "h1", size: "xxlarge", bold: true, children: "Survey" }), _jsx(SurveyFormWrap, { children: _jsx(SurveyIFrame, { "data-testid": "pro-survey-iframe", src: src }) }), _jsx(Footer, { children: _jsx(Button, { onClick: submit ?? onClose, children: submitText ?? 'Close' }) })] }));
};
IFrameModal.displayName = 'IFrameModal';
const Footer = styled(Row)({
    justifyContent: 'flex-end',
    marginTop: '-45px',
});
const SurveyFormWrap = styled.div({
    paddingRight: '24px',
    width: '100%',
    height: '95%',
    overflow: 'hidden',
});
const SurveyIFrame = styled.iframe({
    width: '100%',
    height: '70vh',
    overflow: 'hidden',
});
//# sourceMappingURL=i_frame_modal.js.map